var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"left",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../../assets/cancel.png"),"alt":""}})]),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }